import { createAction } from '@reduxjs/toolkit';

import type { ListingCommentData } from '@app/api/collaboration';
import type { CommentList } from '@app/features/comments/components/CommentsSidebar/types';
import { commentsSlice } from '@app/features/comments/store/reducers';

type CommentFocusedInEditorPayload = {
    comment: ListingCommentData;
    commentIndex: number | undefined;
    nextListType: CommentList;
};
const commentFocusedInEditor = createAction<CommentFocusedInEditorPayload>('comments/commentFocusedInEditor');

const {
    keyCommentsOpenedFromEditor,
    translationCommentsOpenedFromEditor,
    newCommentStackStarted,
    commentListOpened,
    backToPreviousCommentList,
    updateActiveCommentList,
    removeActiveCommentListScrollPosition,
    updateActiveCommentListScrollPosition,
    closeSidebar,
    openSidebar,
} = commentsSlice.actions;

const commentsActions = {
    keyCommentsOpenedFromEditor,
    translationCommentsOpenedFromEditor,
    newCommentStackStarted,
    commentListOpened,
    backToPreviousCommentList,
    updateActiveCommentList,
    removeActiveCommentListScrollPosition,
    updateActiveCommentListScrollPosition,
    closeSidebar,
    openSidebar,
    commentFocusedInEditor,
};

export default commentsActions;
